// extracted by mini-css-extract-plugin
export default {"container":"CategoryOne_container__azdel","wrapper":"CategoryOne_wrapper__-7-Uv","heading":"CategoryOne_heading__aCRlU","cardWrapper":"CategoryOne_cardWrapper__K10C5"};